// extracted by mini-css-extract-plugin
export default {"root":"b5Wi9to813GLILlzP8yI","main":"WmR2M7DcTb02AKCsPMvc"};